import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=c59fb816"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"
import style0 from "./CartItem.vue?vue&type=style&index=0&id=c59fb816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports